import styled, { css, keyframes } from 'styled-components';
import {
  white,
  buttonColor,
  breakpointsMinWidth,
  bluishbuttonColor,
} from '../../../../../../../../common/styling';

export const ContentWrapper = styled.div`
  perspective: 1000px;
  grid-column: 1/ -1;
  color: ${white};
  position: absolute;
  top: ${(props) => (props.higherEd ? '76px' : '64px')};
  text-align: center;
  padding: 0 15px;

  @media screen and (min-width: 411px) {
    width: 100%;
    top: ${(props) => (props.higherEd ? '80px' : '70px')};
  }
  @media ${breakpointsMinWidth.tabletSm} {
    grid-column: 3/ 7;
    width: 100%;
    top: ${(props) => (props.higherEd ? '60px' : '77px')};
    padding: 0;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    grid-column: 4/ 9;
    transform: translateX(40px);
    width: 100%;
    top: ${(props) => (props.higherEd ? '60px' : '82px')};
  }
  @media ${breakpointsMinWidth.tabletLg} {
    grid-column: 4/ 10;
    width: 100%;
    top: ${(props) => (props.higherEd ? '65px' : '93px')};
    transform: translateX(0);
  }
  @media ${breakpointsMinWidth.desktopSm} {
    top: ${(props) => (props.higherEd ? '80px' : '106px')};
    grid-column: 4/ 10;
    transform: translateX(40px);
    width: 90%;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    top: ${(props) => (props.higherEd ? '110px' : '165px')};
    grid-column: 4/ 10;
    transform: none;
    width: 100%;
  }

  ${({ higherEd }) => {
    if (higherEd) {
      return css`
        justify-self: center;
        @media ${breakpointsMinWidth.tabletMd} {
          transform: none;
        }
        @media ${breakpointsMinWidth.tabletLg} {
          transform: none;
        }
        @media ${breakpointsMinWidth.desktopSm} {
          transform: none;
        }
        @media ${breakpointsMinWidth.desktopMd} {
          transform: none;
        }
      `;
    }
    return css``;
  }}
`;
export const HeadWrapper = styled.div`
  font-size: 20px;
  line-height: ${(props) => (props.higherEd ? '32px' : '40px')};
  font-weight: 500;
  height: 40px;

  @media ${breakpointsMinWidth.tabletSm} {
    font-size: 24px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    font-size: 28px;
    line-height: 48px;
    height: 48px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    font-size: 32px;
    line-height: 64px;
    height: 64px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    font-size: 36px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 48px;
  }
`;
export const SmallerText = styled.div`
  font-size: 12px;
  line-height: 24px;
  font-weight: 400;
  padding-top: ${(props) => (props.higherEd ? '48px' : '8px')};

  @media screen and (min-width: 411px) {
    font-size: 14px;
    line-height: 16px;
  }
  @media ${breakpointsMinWidth.tabletSm} {
    font-size: 14px;
    line-height: 20px;
    width: ${(props) => (props.higherEd ? '80%' : '100%')};
    margin: ${(props) => (props.higherEd ? '0 auto' : 'none')};
    padding-top: ${(props) => (props.higherEd ? '16px' : '8px')};
  }
  @media ${breakpointsMinWidth.tabletMd} {
    font-size: 16px;
    width: ${(props) => (props.higherEd ? '65%' : '80%')};
    margin: 0 auto;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding-top: 16px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    font-size: ${(props) => (props.higherEd ? '20px' : '16px')};
    padding-top: ${(props) => (props.higherEd ? '30px' : '16px')};
    width: 70%;
    margin: auto;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    width: ${(props) => (props.higherEd ? '56%' : '80%')};
    margin: none;
    font-size: 20px;
    line-height: 36px;
    padding-top: 30px;
    font-size: ${(props) => (props.higherEd ? '28px' : '16px')};
    padding-top: ${(props) => (props.higherEd ? '36px' : '16px')};
  }
`;
export const Button = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  justify-content: center;
  z-index: 1;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  width: 200px;
  height: 40px;
  margin: 0 auto;
  margin-top: 40px;
  background: ${white};
  color: ${bluishbuttonColor};
  border-radius: 4px;
  border: ${(props) => (props.inverted ? `2px solid ${props.color}` : 'none')};
  cursor: pointer;
  margin-bottom: ${(props) => (props.higherEd ? '40px' : '0px')};

  @media screen and (min-width: 360px) {
    width: 177px;
    height: 32px;
    margin-top: 24px;
    margin-bottom: ${(props) => (props.higherEd ? '24px' : '0px')};
  }

  @media ${breakpointsMinWidth.tabletMd} {
    margin-top: ${(props) => (props.higherEd ? '16px' : '32px')};
    margin-bottom: ${(props) => (props.higherEd ? '16px' : '0px')};
  }
  @media ${breakpointsMinWidth.tabletMd} {
    width: 144px;
    height: ${(props) => (props.higherEd ? '36px' : '40px')};
    margin-top: ${(props) => (props.higherEd ? '18px' : '32px')};
    margin-bottom: ${(props) => (props.higherEd ? '18px' : '0px')};
  }
  @media ${breakpointsMinWidth.tabletLg} {
    height: ${(props) => (props.higherEd ? '36px' : '40px')};
    width: ${(props) => (props.higherEd ? '180px' : '200px')};
    margin-top: ${(props) => (props.higherEd ? '20px' : '40px')};
    margin-bottom: ${(props) => (props.higherEd ? '20px' : '0px')};
  }
  @media ${breakpointsMinWidth.desktopSm} {
    margin-top: 28px;
    margin-bottom: ${(props) => (props.higherEd ? '28px' : '0px')};
  }
  @media ${breakpointsMinWidth.desktopMd} {
    width: 240px;
    height: 48px;
    font-size: 14px;
    margin-top: 32px;
    margin-bottom: ${(props) => (props.higherEd ? '32px' : '0px')};
  }

  &:hover {
    color: ${white};
    border: 2px solid ${white};

    // For outside hero section
    ${(props) => {
      const { card, color, inverted } = props;
      if (card) {
        return css`
          color: ${inverted ? `${white}` : color};
          border: 2px solid ${color};
        `;
      }
      return css``;
    }}
  }

  overflow: hidden;
  position: relative;

  // For card  section
  ${(props) => {
    const { card, color, inverted } = props;
    if (card) {
      return css`
        margin: 0 auto;
        background: ${inverted ? `${white}` : color};
        color: ${inverted ? color : `${white}`};

        @media screen and (max-width: 1280px) {
          margin-top: 10px;
          width: 247px;
          height: 28px;
        }
        @media ${breakpointsMinWidth.tabletLg} {
          margin-top: 12px;
        }
        @media ${breakpointsMinWidth.desktopSm} {
          margin-top: 16px;
        }
        @media ${breakpointsMinWidth.tabletLg} {
          width: 280px;
          height: 40px;
          font-size: ${inverted ? '14px' : '16px'};
        }
        @media ${breakpointsMinWidth.desktopMd} {
          width: 303px;
          height: 48px;
          font-size: ${inverted ? '14px' : '16px'};
        }
      `;
    }
    return css``;
  }}

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // border-radius: 4px;
    transition:
      opacity 0.3s,
      border 0.3s;
  }
  &:hover::before {
    opacity: 0;
  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 400px;
    height: 400px;
    background-color: ${buttonColor};
    border-color: transparent;
    border-radius: 50%;
    transform: translate(-20%, -45%) scale(0.05);
    opacity: 0;
    z-index: -1;
    transition:
      transform 0.4s,
      opacity 0.4s,
      background-color 0.4s ease-in-out;

    @media ${breakpointsMinWidth.tabletMd} {
      transform: translate(-25%, -43.5%) scale(0.1);
    }
    @media ${breakpointsMinWidth.tabletLg} {
      transform: translate(-18%, -43.5%) scale(0.1);
    }
    @media ${breakpointsMinWidth.desktopSm} {
      transform: translate(-15%, -43%) scale(0.1);
    }
    @media ${breakpointsMinWidth.desktopMd} {
      transform: translate(-10%, -42%) scale(0.1);
    }

    // For card section
    ${(props) => {
      const { card, color, inverted } = props;
      if (card) {
        return css`
          width: 350px;
          height: 350px;
          background: ${white};
          background: ${inverted ? color : `${white}`};
          color: ${inverted ? `${white}` : color};
          border: 2px solid ${color};

          @media screen and (max-width: 1024px) {
            transform: translate(-15%, -46%) scale(0.05);
          }
          @media ${breakpointsMinWidth.tabletMd} {
            transform: translate(-12%, -46%) scale(0.04);
          }
          @media ${breakpointsMinWidth.tabletLg} {
            transform: translate(-8%, -44%) scale(0.1);
          }
          @media ${breakpointsMinWidth.desktopSm} {
            transform: translate(-10%, -44%) scale(0.1);
          }
          @media ${breakpointsMinWidth.desktopMd} {
            transform: translate(-7%, -43%) scale(0.1);
          }
        `;
      }
      return css``;
    }}
  }

  &:hover::after {
    opacity: 1;
    transform-origin: 150px 150px;
    transform: scale(1) translate(-10%, -42%);
  }
`;

const textAnimate = keyframes`
      0%{
        transform: rotateX(0deg);
      }
      20%{
        transform: rotateX(0deg);
      }
      25%{
        transform: rotateX(90deg) translateY(-40px);
      }
      75%{
        transform: rotateX(90deg) translateY(-40px);
      }
      80%{
        transform: rotateX(0deg);
      }
      100%{
        transform: rotateX(0deg);
      }
`;

export const Alternatetext = styled.span`
  position: relative;
  display: inline-block;
  padding: 0;
  transition: transform 0.3s;
  transform-origin: 50% 0;
  transform-style: preserve-3d;
  height: 80%;
  width: 100%;

  ${({ higherEd }) => {
    if (higherEd) {
      return css`
        &::before {
          position: absolute;
          top: 100%;
          left: 0;
          width: 100%;
          height: 80%;
          content: 'Your Resume-Building AI Companion';
          transform-origin: 50% 0;
          text-align: center;
          transform: rotateX(-90deg);
        }
      `;
    }
    return css`
      &::before {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        height: 80%;
        content: 'AI Powered Resume Review';
        transform-origin: 50% 0;
        text-align: center;
        transform: rotateX(-90deg);
      }
    `;
  }}

  animation: ${textAnimate} 8s infinite;
`;
